module.exports = __webpack_public_path__ + "img/0-122.425bf119.jpg";